import React, { useState, useMemo, useEffect } from "react";
import { TYPE_GET_DATE } from "../../../helper/const";
import { getDateChangeTime, getLastDay } from "../../../helper/helper";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../components/Breadcrumbs";
// import FilterTime from "../components/FilterTime";
import { Tabs } from "antd";
import Overview from "./Overview";
import Details from "./Detail";
import Compare from "./Compare";
import { getDataNatcom, getDataNatcomAirtime, getDataNatcomDigicelVm } from "../../../redux/Future/Natcom/action";

export default function VmailAirtime() {
  const dispatch = useDispatch();
  const [tabActive, setTabActive] = useState("1");

  const handleGetData = (startDate, endDate) => {
    const url = `/api/get-data-vm-natcom-digicel?startDate=${startDate}&endDate=${endDate}`;
    dispatch(getDataNatcomDigicelVm(url));
  };

  const items = [
    {
      key: "1",
      label: "Overview",
      children: (
        <Overview handleGetData={handleGetData} tabActive={tabActive} />
      ),
    },
    {
      key: "2",
      label: "Details",
      children: <Details handleGetData={handleGetData} tabActive={tabActive} />,
    },
    {
      key: "3",
      label: "Compare",
      children: <Compare handleGetData={handleGetData} tabActive={tabActive} />,
    },
  ];

  const onChangeTabs = (key) => {
    setTabActive(key);
  };

  return (
    <Container>
      <Breadcrumbs data={["Natcom", "Vmail"]} />
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-tabs-tab {
    font-size: 15px;
    padding: 5px 20px;
  }
`;
